/* Generato da sito/build/dati.py — non si modifica a mano. */
window.CATALOGO = {
 "prodotti": [
  {
   "id": "halloween-coloring-collection",
   "nome": "The Halloween Coloring Collection",
   "prezzo": 14.99,
   "momento": null,
   "eta": "Ages 3–12",
   "ruolo": "core",
   "file": [
    "little-spooks-coloring-pages",
    "spooky-kids-coloring-pages",
    "brave-explorers-coloring-pages"
   ],
   "gancio": "Three ebooks, one per age. Nobody colors the wrong page.",
   "sotto": "The 4-year-old and the 11-year-old get different pages. That's the whole idea.",
   "badge": "Best seller",
   "voci": [
    "94 Spooky Friends pages: the characters in big, simple poses",
    "119 classic Halloween things, one per page",
    "36 words to color in bubble letters",
    "30 count-and-color pages",
    "11 shape pages",
    "250 full-page scenes, all different, in 31 Halloween settings",
    "150 mandalas",
    "100 stained-glass designs",
    "99 zentangle designs",
    "100 repeating patterns"
   ],
   "pagine": 989,
   "pagine_pdf": 995,
   "campi": 0,
   "pdf_n": 3,
   "img": "halloween-coloring-collection",
   "handle": "the-halloween-coloring-collection"
  },
  {
   "id": "halloween-party-kit",
   "nome": "Halloween Party Kit",
   "prezzo": 11.99,
   "momento": "party-at-home",
   "eta": "Ages 4–12",
   "ruolo": "upsell",
   "file": [
    "halloween-party-kit"
   ],
   "gancio": "Your Halloween party, printed. Not planned — printed.",
   "sotto": "Twelve games, seventy-eight different bingo cards, three scavenger hunts.",
   "voci": [
    "2 party plan pages",
    "12 game pages with the rules",
    "5 pages of game printables",
    "44 bingo pages: 78 different bingo cards and the calling cards",
    "5 scavenger hunt pages",
    "12 pages of game cards",
    "20 pages of costume awards",
    "46 decoration pages",
    "4 “You've Been Booed” pages"
   ],
   "pagine": 150,
   "pagine_pdf": 152,
   "campi": 80,
   "pdf_n": 1,
   "img": "halloween-party-kit",
   "handle": "halloween-party-kit"
  },
  {
   "id": "midnight-candy-mystery-escape-room",
   "nome": "The Midnight Candy Mystery",
   "prezzo": 9.99,
   "momento": "party-at-home",
   "eta": "Ages 6–12",
   "ruolo": "upsell",
   "file": [
    "midnight-candy-mystery-escape-room"
   ],
   "gancio": "A printable escape room. Seven puzzles, one padlock code.",
   "sotto": "Every puzzle has an easier twin for younger players. Same code at the end.",
   "voci": [
    "2 read-aloud story pages",
    "5 host pages: guide, keeper card, envelope labels",
    "11 puzzle pages",
    "7 easier versions for younger players",
    "1 certificate"
   ],
   "pagine": 26,
   "pagine_pdf": 28,
   "campi": 0,
   "pdf_n": 1,
   "img": "midnight-candy-mystery-escape-room",
   "handle": "the-midnight-candy-mystery"
  },
  {
   "id": "editable-halloween-invitations",
   "nome": "Editable Invitations",
   "prezzo": 6.99,
   "momento": "party-at-home",
   "eta": "Any age",
   "ruolo": "catalogo",
   "file": [
    "editable-halloween-invitations"
   ],
   "gancio": "Type your party details, then print.",
   "sotto": "184 fillable fields. No design app, no pen, no handwriting.",
   "voci": [
    "10 invitation designs, 2 per sheet, with fields you can type in",
    "10 pages of thank-you cards",
    "20 party signs"
   ],
   "pagine": 40,
   "pagine_pdf": 42,
   "campi": 184,
   "pdf_n": 1,
   "img": "editable-halloween-invitations",
   "handle": "editable-invitations"
  },
  {
   "id": "classroom-party-edition",
   "nome": "Classroom Party Edition",
   "prezzo": 11.99,
   "momento": "at-school",
   "eta": "Grades K–5",
   "ruolo": "insegnanti",
   "file": [
    "classroom-party-edition"
   ],
   "gancio": "You have 20 minutes for the class party. Here's a plan that fits in 20 minutes.",
   "sotto": "Three timed plans — 20, 30 and 45 minutes — and the pages that go with them.",
   "badge": "For teachers",
   "voci": [
    "1 classroom and group license",
    "3 party plans: 20, 30 and 45 minutes",
    "2 pages of tips, supply list and inclusion ideas",
    "8 station cards",
    "4 station printables and question list",
    "11 mini-book pages: 10 books to fold + how to fold",
    "24 pages of costume awards, with fields you can type in",
    "2 pages of name tags",
    "53 bingo pages: 90 different cards in 3 sets, and the calling cards",
    "3 pages to turn it into a Fall / Harvest party"
   ],
   "pagine": 111,
   "pagine_pdf": 113,
   "campi": 96,
   "pdf_n": 1,
   "img": "classroom-party-edition",
   "handle": "classroom-party-edition"
  },
  {
   "id": "puzzle-and-activity-pack",
   "nome": "Puzzle & Activity Pack",
   "prezzo": 8.99,
   "momento": "quiet-october",
   "eta": "Ages 5–12",
   "ruolo": "bump",
   "file": [
    "puzzle-and-activity-pack"
   ],
   "gancio": "448 pages for the afternoons when it rains.",
   "sotto": "Mazes with exactly one solution. Word searches where every word appears once.",
   "voci": [
    "120 mazes",
    "87 word searches",
    "32 dot-to-dots",
    "40 spot-the-difference pages",
    "40 count-and-find pages",
    "30 picture sudoku",
    "30 secret code puzzles",
    "15 draw-and-finish pages",
    "54 answer pages"
   ],
   "pagine": 448,
   "pagine_pdf": 450,
   "campi": 0,
   "pdf_n": 1,
   "img": "puzzle-and-activity-pack",
   "handle": "puzzle-activity-pack"
  },
  {
   "id": "spooky-friends-story-pack",
   "nome": "Spooky Friends Story Pack",
   "prezzo": 7.99,
   "momento": "quiet-october",
   "eta": "Ages 3–12",
   "ruolo": "catalogo",
   "file": [
    "spooky-friends-story-pack"
   ],
   "gancio": "Twelve read-aloud stories, graded 0.5 to 4.5.",
   "sotto": "Spooky enough to lean in. Not the kind that ends up in your bed at 2 a.m.",
   "voci": [
    "1 page on how to use the pack",
    "40 story pages: 12 read-aloud stories with questions",
    "12 coloring pages, one for each story"
   ],
   "pagine": 53,
   "pagine_pdf": 55,
   "campi": 0,
   "pdf_n": 1,
   "img": "spooky-friends-story-pack",
   "handle": "spooky-friends-story-pack"
  },
  {
   "id": "31-days-of-halloween",
   "nome": "31 Days of Halloween",
   "prezzo": 4.99,
   "momento": "quiet-october",
   "eta": "Ages 3–10",
   "ruolo": "catalogo",
   "file": [
    "31-days-of-halloween"
   ],
   "gancio": "One small spooky thing a day, all October.",
   "sotto": "The candy is over in an hour. October is thirty-one days long.",
   "voci": [
    "1 calendar poster",
    "1 page with the full list of 31 ideas",
    "1 page with 31 pumpkins to color, one a day",
    "31 coloring pages, one for every day in October"
   ],
   "pagine": 34,
   "pagine_pdf": 36,
   "campi": 0,
   "pdf_n": 1,
   "img": "31-days-of-halloween",
   "handle": "31-days-of-halloween"
  },
  {
   "id": "candy-free-treats-mini-books",
   "nome": "Candy-Free Treats",
   "prezzo": 5.99,
   "momento": "no-candy",
   "eta": "Ages 4–10",
   "ruolo": "catalogo",
   "file": [
    "candy-free-treats-mini-books"
   ],
   "gancio": "Ten mini books from ten sheets of paper. Fold, done, no candy.",
   "sotto": "Also included in the Classroom Party Edition — don't buy both.",
   "voci": [
    "10 mini books, one per sheet",
    "1 page on how to fold them"
   ],
   "pagine": 11,
   "pagine_pdf": 13,
   "campi": 0,
   "pdf_n": 1,
   "img": "candy-free-treats-mini-books",
   "handle": "candy-free-treats"
  },
  {
   "id": "teen-and-tween-party-pack",
   "nome": "Teen & Tween Party Pack",
   "prezzo": 7.99,
   "momento": "teens-grownups",
   "eta": "Ages 11–16",
   "ruolo": "catalogo",
   "file": [
    "teen-and-tween-party-pack"
   ],
   "gancio": "Eight games for the age that finds everything cringe.",
   "sotto": "No crafts, no cartoon ghosts, no \"let's all sit in a circle\".",
   "voci": [
    "8 game rule pages",
    "27 pages of game cards",
    "1 photo challenge checklist"
   ],
   "pagine": 36,
   "pagine_pdf": 38,
   "campi": 0,
   "pdf_n": 1,
   "img": "teen-and-tween-party-pack",
   "handle": "teen-tween-party-pack"
  },
  {
   "id": "murder-at-the-midnight-masquerade",
   "nome": "Murder at the Midnight Masquerade",
   "prezzo": 16.99,
   "momento": "teens-grownups",
   "eta": "Ages 13+",
   "ruolo": "upsell",
   "file": [
    "murder-at-the-midnight-masquerade"
   ],
   "gancio": "A murder mystery for 12, with the awkward part removed: nobody has to act.",
   "sotto": "Hosting it is reading a page out loud. That's the job.",
   "voci": [
    "3 host guide pages",
    "9 host script and solution pages",
    "1 guest list poster",
    "6 pages of invitations, 2 per sheet, with fields you can type in",
    "12 character booklets",
    "6 pages of clue cards",
    "2 pages of name tags",
    "1 accusation form"
   ],
   "pagine": 40,
   "pagine_pdf": 42,
   "campi": 48,
   "pdf_n": 1,
   "img": "murder-at-the-midnight-masquerade",
   "handle": "murder-at-the-midnight-masquerade"
  },
  {
   "id": "pumpkin-carving-stencils",
   "nome": "Pumpkin Carving Stencils",
   "prezzo": 7.99,
   "momento": "pumpkin-night",
   "eta": "Adult with a knife",
   "ruolo": "catalogo",
   "file": [
    "pumpkin-carving-stencils"
   ],
   "gancio": "Free stencils collapse at the third cut. These were checked in the geometry.",
   "sotto": "Ninety-six designs in four levels, and the peel stays in one piece.",
   "voci": [
    "1 page on how to use the stencils",
    "24 easy stencils",
    "25 medium stencils",
    "22 hard stencils",
    "25 expert stencils"
   ],
   "pagine": 97,
   "pagine_pdf": 99,
   "campi": 0,
   "pdf_n": 1,
   "img": "pumpkin-carving-stencils",
   "handle": "pumpkin-carving-stencils"
  },
  {
   "id": "complete-halloween-vault",
   "nome": "The Complete Halloween Vault",
   "prezzo": 67.99,
   "momento": null,
   "eta": "The whole house",
   "ruolo": "vault",
   "gancio": "Everything above. Twelve ebooks, fourteen PDFs, one download.",
   "sotto": "Bought separately the same pages cost $110.89.",
   "badge": "Best value",
   "file": [
    "little-spooks-coloring-pages",
    "spooky-kids-coloring-pages",
    "brave-explorers-coloring-pages",
    "puzzle-and-activity-pack",
    "halloween-party-kit",
    "midnight-candy-mystery-escape-room",
    "editable-halloween-invitations",
    "teen-and-tween-party-pack",
    "classroom-party-edition",
    "spooky-friends-story-pack",
    "31-days-of-halloween",
    "candy-free-treats-mini-books",
    "murder-at-the-midnight-masquerade",
    "pumpkin-carving-stencils"
   ],
   "voci": [
    "The Halloween Coloring Collection — 989 pages",
    "Halloween Party Kit — 150 pages",
    "The Midnight Candy Mystery — 26 pages",
    "Editable Invitations — 40 pages",
    "Classroom Party Edition — 111 pages",
    "Puzzle & Activity Pack — 448 pages",
    "Spooky Friends Story Pack — 53 pages",
    "31 Days of Halloween — 34 pages",
    "Candy-Free Treats — 11 pages",
    "Teen & Tween Party Pack — 36 pages",
    "Murder at the Midnight Masquerade — 40 pages",
    "Pumpkin Carving Stencils — 97 pages"
   ],
   "pagine": 2024,
   "pagine_pdf": 2063,
   "campi": 408,
   "pdf_n": 14,
   "img": "complete-halloween-vault",
   "nota_pagine": "2,035 pages of content, minus the 11 mini-book pages that appear in two of the ebooks = 2,024 unique pages.",
   "prezzo_pieno": 110.89,
   "handle": "the-complete-halloween-vault"
  }
 ],
 "piani": [
  {
   "minuti": 20,
   "gruppi": "3 groups",
   "timeline": [
    {
     "quando": "0–2",
     "cosa": "Welcome. Kids go to their group's first station."
    },
    {
     "quando": "2–17",
     "cosa": "3 stations, 5 minutes each. Rotate on the signal."
    },
    {
     "quando": "17–20",
     "cosa": "Clean up together and hand out mini-books."
    }
   ],
   "stazioni": [
    "Ghost Bowling",
    "60-Second Challenge: Spider Sweep",
    "Mini-Book Corner"
   ],
   "volontari": 4,
   "materiali": 8
  },
  {
   "minuti": 30,
   "gruppi": "4 groups",
   "timeline": [
    {
     "quando": "0–3",
     "cosa": "Welcome. Kids go to their group's first station."
    },
    {
     "quando": "3–23",
     "cosa": "4 stations, 5 minutes each. Rotate on the signal."
    },
    {
     "quando": "23–28",
     "cosa": "Whole-class bingo: picture bingo for K–2, word bingo for grades 3–5."
    },
    {
     "quando": "28–30",
     "cosa": "Guess How Many reveal, mini-books, and goodbye."
    }
   ],
   "stazioni": [
    "Mummy Wrap Race",
    "Ghost Bowling",
    "Witch Hat Ring Toss",
    "Mini-Book Corner"
   ],
   "volontari": 5,
   "materiali": 10
  },
  {
   "minuti": 45,
   "gruppi": "5 groups",
   "timeline": [
    {
     "quando": "0–5",
     "cosa": "Welcome and Monster Freeze Dance with the whole class."
    },
    {
     "quando": "5–30",
     "cosa": "5 stations, 5 minutes each. Rotate on the signal."
    },
    {
     "quando": "30–38",
     "cosa": "Whole-class bingo: picture bingo for K–2, word bingo for grades 3–5."
    },
    {
     "quando": "38–43",
     "cosa": "Costume parade with diplomas. No costumes at your school? Play a quick Would You Rather round instead."
    },
    {
     "quando": "43–45",
     "cosa": "Guess How Many reveal, mini-books, and goodbye."
    }
   ],
   "stazioni": [
    "Mummy Wrap Race",
    "Pin the Smile on the Jack-o'-Lantern",
    "60-Second Challenge: Boo's Breeze",
    "Witch Hat Ring Toss",
    "Mini-Book Corner"
   ],
   "volontari": 7,
   "materiali": 14
  }
 ],
 "momenti": [
  {
   "id": "party-at-home",
   "nome": "Party at home",
   "sotto": "The two hours in the middle, printed."
  },
  {
   "id": "at-school",
   "nome": "At school & groups",
   "sotto": "The last 20 minutes of a Friday, with 28 kids."
  },
  {
   "id": "quiet-october",
   "nome": "Quiet October days",
   "sotto": "The thirty-one evenings before the one night."
  },
  {
   "id": "no-candy",
   "nome": "Treats that aren't candy",
   "sotto": "For the kid with the allergy, and the teal pumpkin."
  },
  {
   "id": "teens-grownups",
   "nome": "Teens & grown-ups",
   "sotto": "Halloween for people who stopped trick-or-treating."
  },
  {
   "id": "pumpkin-night",
   "nome": "Pumpkin night",
   "sotto": "The knife, the newspaper, the seeds everywhere."
  }
 ],
 "volumi": [
  {
   "id": "little-spooks-coloring-pages",
   "nome": "Little Spooks",
   "eta": "3–5",
   "testo": "Thick, friendly lines and big spaces for little hands.",
   "pagine": 290,
   "voci": [
    "94 Spooky Friends pages: the characters in big, simple poses",
    "119 classic Halloween things, one per page",
    "36 words to color in bubble letters",
    "30 count-and-color pages",
    "11 shape pages"
   ]
  },
  {
   "id": "spooky-kids-coloring-pages",
   "nome": "Spooky Kids",
   "eta": "6–8",
   "testo": "Full scenes to explore, with something to find on every page.",
   "pagine": 250,
   "voci": [
    "250 full-page scenes, all different, in 31 Halloween settings"
   ]
  },
  {
   "id": "brave-explorers-coloring-pages",
   "nome": "Brave Explorers",
   "eta": "9–12",
   "testo": "Mandalas, stained glass and zentangles, so nothing feels babyish.",
   "pagine": 449,
   "voci": [
    "150 mandalas",
    "100 stained-glass designs",
    "99 zentangle designs",
    "100 repeating patterns"
   ]
  }
 ],
 "amici": [
  {
   "id": "pip",
   "nome": "Pip",
   "pron": "she",
   "testo": "A round, cheerful little pumpkin. Brave, and always first through the gate."
  },
  {
   "id": "boo",
   "nome": "Boo",
   "pron": "he",
   "testo": "A shy little ghost who would rather hug you than haunt you."
  },
  {
   "id": "luna",
   "nome": "Luna",
   "pron": "she",
   "testo": "A little bat who is secretly afraid of the dark."
  },
  {
   "id": "midnight",
   "nome": "Midnight",
   "pron": "he",
   "testo": "A curious black cat who pokes his nose into everything."
  },
  {
   "id": "olive",
   "nome": "Olive",
   "pron": "she",
   "testo": "A wise owl who loves books and riddles."
  },
  {
   "id": "gus",
   "nome": "Gus",
   "pron": "he",
   "testo": "A big, fuzzy, gentle monster who bakes cookies."
  },
  {
   "id": "webster",
   "nome": "Webster",
   "pron": "he",
   "testo": "A teeny spider in a top hat who weaves drawings into his web."
  },
  {
   "id": "mumford",
   "nome": "Mumford",
   "pron": "he",
   "testo": "A slightly clumsy mummy who unravels at the wrong moment."
  }
 ],
 "totali": {
  "pagine_uniche": 2024,
  "pdf": 14,
  "prodotti": 12,
  "pagine_collection": 989
 }
};
